import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { environmentProd } from '../../environments/environment.prod';
import { environmentDev } from '../../environments/environment.dev';
import { firstValueFrom } from 'rxjs';
@Component({
  selector: 'app-visor-documento',
  templateUrl: './visor-documento.component.html',
  styleUrls: ['./visor-documento.component.css']
})
export class VisorDocumentoComponent {

  constructor(private http: HttpClient, private route: ActivatedRoute) { }
  folderId: number = 0
  async ngOnInit() {
    await delay(3000)
    await this.consultaEstado()

    if (await this.validator()) {
      do {
        await delay(30000)

        await this.consultaEstado()
        await delay(1500)
      } while (await this.validator());
    }

  }


  url = ''
  pdfObj: any;
  estado: number = -1;
  estadoADO: number = 0;
  cedula: number = 0;
  carpeta: number = 0;

  src: string = '';
  src2: string = '';
  nomFile: string = '';
  nomFileDow: string = '';


  downloadPdf() {
    const source = this.src;
    const link = document.createElement("a");
    link.href = source;
    link.download = this.nomFileDow
    link.click();
  }
  tokenUrl() {
    let urlToken
    if (environment.production) {
      urlToken = environmentProd.tokenUrl
    } else {
      urlToken = environmentDev.tokenUrl
    }
    const body = {
      userName: environment.userName,
      password: environment.password
    };
    this.http.post<any>(urlToken, body, { observe: 'response' }).subscribe(async data => {
      const token = data.headers.get('Authorization')
      this.urlBase(token)
    })
  }

  urlBase(token: any) {
    let body
    let urlConsumo

    if (environment.production) {
      urlConsumo = environmentProd.urlBase
      body = {
        cedula: this.cedula,
        nui: environmentProd.nui,
        canal: environmentProd.canal,
        carpeta: this.carpeta,
        requiere_firma: environmentProd.requiere_firma,
        session: environmentProd.session,
        documentos: [
          this.nomFile
        ]
      };
    } else {
      urlConsumo = environmentDev.urlBase
      body = {
        cedula: this.cedula,
        nui: environmentDev.nui,
        canal: environmentDev.canal,
        carpeta: this.carpeta,
        requiere_firma: environmentDev.requiere_firma,
        session: environmentDev.session,
        documentos: [
          this.nomFile
        ]
      };
    }

    this.http.post<any>(urlConsumo, body, { headers: new HttpHeaders().set('Authorization', token) }).subscribe(data => {
      this.url = data.url;
      location.href = this.url
    })
  }
  async validator() {
    let validar = (this.estado == 3 && this.src2 == '') || (this.estado == 2 && this.estadoADO == 1) || (this.estado == 2 && this.estadoADO == 14) || (this.estado == 2 && this.estadoADO == 2) || (this.estado == 3 && this.src2 === null)
    return validar
  }
  consultaEstado = async () => {
    let urlConsultaEstado;

    if (environment.production) {
      urlConsultaEstado = environmentProd.urlConsultaEstado;
    } else {
      urlConsultaEstado = environmentDev.urlConsultaEstado;
    }

    const body = {
      folder_id: this.route.snapshot.paramMap.get('idFolder'),
    };

    try {
      const data = await firstValueFrom(
        this.http.post<any>(urlConsultaEstado, body)
      );
      this.estado = data.data.status_document_id;
      this.src = 'data:application/pdf;base64,' + data.data.document_base64;
      this.src2 = data.data.document_base64;
      this.cedula = data.data.identification;
      this.carpeta = data.data.code;
      this.nomFile = data.data.name_file;
      this.nomFileDow = data.data.name_file;

      if (data.data.status_ADO == null || data.data.status_ADO == '') {
        this.estadoADO = 0;
      } else {
        this.estadoADO = data.data.status_ADO
      }
    } catch (error) {
      console.error('Error en consultaEstado:', error);
      throw error; // Propaga el error si es necesario
    }
  };
}

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
